var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import BackgroundIcon from './BackgroundIcon';
import { getIconContainerParams } from './params';
import { IconContainerContent } from './styles';
const IconContainer = (_a) => {
    var _b, _c, _d;
    var { children, pageTag } = _a, containerProps = __rest(_a, ["children", "pageTag"]);
    const params = useMemo(() => getIconContainerParams(pageTag), [pageTag]);
    const iconContainerProps = Object.assign(Object.assign({}, containerProps), { containerBackgroundColor: !!containerProps.containerBackgroundColor
            ? containerProps.containerBackgroundColor
            : params.backgroundColor, styles: Object.assign(Object.assign({}, containerProps.styles), { container: Object.assign({ overflow: 'hidden' }, (_b = containerProps.styles) === null || _b === void 0 ? void 0 : _b.container), content: Object.assign({ position: 'relative' }, (_c = containerProps.styles) === null || _c === void 0 ? void 0 : _c.content) }) });
    return (_jsxs(IconContainerContent, Object.assign({}, iconContainerProps, { children: [(_d = params === null || params === void 0 ? void 0 : params.icons) === null || _d === void 0 ? void 0 : _d.map((iconParams, i) => (_jsx(BackgroundIcon, { iconParams: iconParams }, `${iconParams.side}-${i}-${pageTag}`))), children] })));
};
export default IconContainer;
